import { render, staticRenderFns } from "./AuthorityEmployeeInAuthorityList.vue?vue&type=template&id=0cd52990&scoped=true"
import script from "./AuthorityEmployeeInAuthorityList.vue?vue&type=script&lang=js"
export * from "./AuthorityEmployeeInAuthorityList.vue?vue&type=script&lang=js"
import style0 from "./AuthorityEmployeeInAuthorityList.vue?vue&type=style&index=0&id=0cd52990&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd52990",
  null
  
)

export default component.exports